'use client'

import type { CardStatus } from 'my-purchases/types/purchaseList'

import { StatusContent } from './content/StatusContent'

interface StatusProps {
	'data-testid'?: string
	status: CardStatus[] | CardStatus | null
	className?: string
}

export function Status({
	'data-testid': dataTestId,
	status,
	className,
}: StatusProps) {
	if (!status) {
		return null
	}

	if (Array.isArray(status)) {
		return status.map((element) => (
			<StatusContent
				key={element.orderId}
				statusTitle={element.statusTitle}
				statusMessage={element.statusMessage}
				statusTitlePlaceholders={element.statusTitlePlaceholders}
				statusMessagePlaceholders={element.statusMessagePlaceholders}
				screenReaderText={element.screenReaderText}
				isAlert={element.isAlert}
				className={className}
				isMulti
				{...(dataTestId && { 'data-testid': `${dataTestId}.status` })}
			/>
		))
	}

	return (
		<StatusContent
			data-testid={`${dataTestId}.status`}
			statusTitle={status.statusTitle}
			statusMessage={status.statusMessage}
			statusTitlePlaceholders={status.statusTitlePlaceholders}
			statusMessagePlaceholders={status.statusMessagePlaceholders}
			screenReaderText={status.screenReaderText}
			isAlert={status.isAlert}
			className={className}
			{...(dataTestId && { 'data-testid': `${dataTestId}.status` })}
		/>
	)
}
